import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { resolutionPropType } from "app/utils/propTypes";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import "./FidelityCardNumberInput.scss";
import InputFormik from "app/pages/.shared/form/InputFormik";
import LoyaltyProgramLogo from "@brand/images/logos/LoyaltyProgramLogo";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

const FidelityCardNumberInput = ({ airlineCode, id, resolution, loyalty }) => {
	const { track } = useAnalytics();
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	const labelID = isMobile
		? "general.frequent.traveler.card.number.short"
		: "general.frequent.traveler.card.number";

	const handleBlur = event => {
		if (event.target.value) {
			track("loyalty_card_input_filled", { loyalty });
		}
	};

	return (
		<div className="fidelity-card-number-input">
			<InputFormik
				label={<FormattedMessage id={labelID} values={{ loyalty }} />}
				name={`${id}.frequentFlyerTravellerCardNumber`}
				id={`${id}-airline-fidelity-logo`}
				data-testid={`fidelity-card-number-input-${id}`}
				onBlur={handleBlur}
			/>

			{airlineCode && (
				<LoyaltyProgramLogo
					className="fidelity-card-number-input__logo"
					alt={airlineCode}
				/>
			)}
		</div>
	);
};

FidelityCardNumberInput.propTypes = {
	airlineCode: PropTypes.string,
	id: PropTypes.string,
	resolution: resolutionPropType,
	loyalty: PropTypes.string,
};

export default FidelityCardNumberInput;
